function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Globe = function Globe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M12 2.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M9.868 5.207C9.188 6.908 8.75 9.31 8.75 12s.438 5.092 1.118 6.793c.34.852.728 1.492 1.12 1.906.39.412.732.551 1.012.551s.622-.139 1.012-.551c.392-.414.78-1.054 1.12-1.907.68-1.7 1.118-4.102 1.118-6.792s-.438-5.092-1.118-6.793c-.34-.852-.728-1.492-1.12-1.906-.39-.412-.732-.551-1.012-.551s-.622.139-1.012.551c-.392.414-.78 1.054-1.12 1.906m.03-2.936c.567-.6 1.277-1.021 2.102-1.021s1.535.421 2.102 1.02c.565.598 1.04 1.423 1.423 2.38.767 1.919 1.225 4.518 1.225 7.35s-.458 5.431-1.225 7.35c-.383.957-.858 1.782-1.423 2.38-.567.599-1.277 1.02-2.102 1.02s-1.535-.421-2.102-1.02c-.565-.598-1.04-1.423-1.423-2.38C7.708 17.43 7.25 14.832 7.25 12s.458-5.431 1.225-7.35c.383-.957.858-1.782 1.423-2.38",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M9.868 5.207C9.188 6.908 8.75 9.31 8.75 12s.438 5.092 1.118 6.793c.34.852.728 1.492 1.12 1.906.39.412.732.551 1.012.551s.622-.139 1.012-.551c.392-.414.78-1.054 1.12-1.907.68-1.7 1.118-4.102 1.118-6.792s-.438-5.092-1.118-6.793c-.34-.852-.728-1.492-1.12-1.906-.39-.412-.732-.551-1.012-.551s-.622.139-1.012.551c-.392.414-.78 1.054-1.12 1.906m.03-2.936c.567-.6 1.277-1.021 2.102-1.021s1.535.421 2.102 1.02c.565.598 1.04 1.423 1.423 2.38.767 1.919 1.225 4.518 1.225 7.35s-.458 5.431-1.225 7.35c-.383.957-.858 1.782-1.423 2.38-.567.599-1.277 1.02-2.102 1.02s-1.535-.421-2.102-1.02c-.565-.598-1.04-1.423-1.423-2.38C7.708 17.43 7.25 14.832 7.25 12s.458-5.431 1.225-7.35c.383-.957.858-1.782 1.423-2.38",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M21 8.75H3v-1.5h18z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M21 8.75H3v-1.5h18z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M21 16.75H3v-1.5h18z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M21 16.75H3v-1.5h18z",
    clipRule: "evenodd"
  }));
};
export default Globe;
Globe.displayName = 'Globe';